export default "__VITE_ASSET__tiagMYGP__"